import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import frCommon from './locales/fr/common.json';
import enCommon from './locales/en/common.json';
import frAuth from './locales/fr/auth.json';
import enAuth from './locales/en/auth.json';
import frDashboard from './locales/fr/dashboard.json';
import enDashboard from './locales/en/dashboard.json';
import frLegal from './locales/fr/legal.json';
import enLegal from './locales/en/legal.json';
import frSettings from './locales/fr/settings.json';
import enSettings from './locales/en/settings.json';
import frBilling from './locales/fr/billing.json';
import enBilling from './locales/en/billing.json';
import frUpscale from './locales/fr/upscale.json';
import enUpscale from './locales/en/upscale.json';
import frCredits from './locales/fr/credits.json';
import enCredits from './locales/en/credits.json';
import frLanding from './locales/fr/landing.json';
import enLanding from './locales/en/landing.json';

const resources = {
  fr: {
    common: frCommon,
    auth: frAuth,
    dashboard: frDashboard,
    legal: frLegal,
    settings: frSettings,
    billing: frBilling,
    upscale: frUpscale,
    credits: frCredits,
    landing: frLanding,
  },
  en: {
    common: enCommon,
    auth: enAuth,
    dashboard: enDashboard,
    legal: enLegal,
    settings: enSettings,
    billing: enBilling,
    upscale: enUpscale,
    credits: enCredits,
    landing: enLanding,
  },
};

const detectionOptions = {
  order: ['localStorage', 'cookie', 'querystring', 'navigator'],
  caches: ['localStorage', 'cookie'],
  lookupQuerystring: 'lang',
  lookupLocalStorage: 'muzo_lang',
  lookupCookie: 'muzo_lang',
  htmlTag: typeof document !== 'undefined' ? document.documentElement : undefined,
};

const updateHtmlLang = (lng) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng;
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en'],
    ns: ['common', 'auth', 'dashboard', 'legal', 'settings', 'billing', 'upscale', 'credits', 'landing'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    detection: detectionOptions,
    returnEmptyString: false,
    react: {
      useSuspense: false,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
    },
  });

updateHtmlLang(i18n.language);
i18n.on('languageChanged', updateHtmlLang);

export default i18n;
